import { useState } from 'react';
import { faBars, faTimes, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/img/logo/vrpad-logo.svg';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';


const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { t } = useTranslation();

    const openMenu = () => {
        setIsMenuOpen(true);
        document.documentElement.style.overflow = 'hidden';
    };

    const closeMenu = (event: React.MouseEvent) => {
        if (event) event.preventDefault();
        setIsMenuOpen(false);
        document.documentElement.style.overflow = 'auto';
    };

    const scrollToSection = (event: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
        event.preventDefault();
        const section = document.getElementById(sectionId);
        if (section) {
            window.scrollTo({
                top: section.offsetTop - 80,
                behavior: 'smooth'
            });
        }
        closeMenu(event);
    };

    return (
        <>
            <header
                id="header"
                className="p-6 flex justify-between items-center fixed md:absolute top-0 left-0 w-full z-30 bg-white md:bg-transparent shadow-md md:shadow-none left-1/2 transform -translate-x-1/2"
                style={{ maxWidth: "var(--width-header)" }}
            >
                {/* Logo */}
                <a href="#hero" onClick={(e) => scrollToSection(e, "hero")}>
                  <img src={logo} alt="VRPAD logo" className="w-[101px] z-50" />
                </a>

                {/* Desktop navigation */}
                <nav className="hidden lg:flex">
                    <ul className="flex gap-10 text-center">
                        <li><a href="#jak-to-funguje" onClick={(e) => scrollToSection(e, "jak-to-funguje")}>{t('navigation.howItWorks')}</a></li>
                        <li><a href="#vyuziti" onClick={(e) => scrollToSection(e, "vyuziti")}>{t('navigation.vrBenefits')}</a></li>
                        <li><a href="#vr-ve-zdravotnictvi" onClick={(e) => scrollToSection(e, "vr-ve-zdravotnictvi")}>{t('navigation.vrInHealthcare')}</a></li>
                        <li><a href="#cenik" onClick={(e) => scrollToSection(e, "cenik")}>{t('navigation.pricing')}</a></li>
                        <li><a href="#proc-vrpad" onClick={(e) => scrollToSection(e, "proc-vrpad")}>{t('navigation.whyVrpad')}</a></li>
                        <li><a href="#kontakt" onClick={(e) => scrollToSection(e, "kontakt")} className="hidden lg:block">{t('navigation.contact')}</a></li>
                    </ul>
                </nav>

                {/* Desktop contact button */}

                <div className="hidden lg:block">
                    <LanguageSwitcher />
                </div>

                {/* Mobile menu button */}
                <button onClick={openMenu} className="lg:hidden text-2xl z-50 cursor-pointer" aria-label="Open menu">
                    <FontAwesomeIcon icon={faBars} />
                </button>
            </header>

            {/* Overlay */}
            {isMenuOpen && (
                <div
                    className="fixed inset-0 bg-[#00000060] z-40 transition-opacity duration-300 lg:hidden"
                    onClick={closeMenu}
                ></div>
            )}

            {/* Mobile off-canvas menu */}
            <div id='mobile-menu'
                className={`fixed top-0 left-0 w-[80%] max-w-[320px] h-full bg-white shadow-lg z-50 transform lg:hidden ${
                    isMenuOpen ? 'translate-x-0' : '-translate-x-full'
                } transition-transform duration-300 flex flex-col`}
            >
                {/* Close button */}
                <button onClick={closeMenu} className="absolute top-5 right-5 text-2xl cursor-pointer" aria-label="Close menu">
                    <FontAwesomeIcon icon={faTimes} />
                </button>


                {/* Mobile navigation */}
                <nav className="mt-20 p-6 flex-grow flex flex-col justify-center">
                  <a href="#hero" onClick={(e) => scrollToSection(e, "hero")}>
                    <img src={logo} alt="VRPAD logo" width={150} className='mx-auto mb-10' />
                  </a>
                    <ul className="flex flex-col gap-6 text-lg text-center">
                        <li><a href="#jak-to-funguje" onClick={(e) => scrollToSection(e, "jak-to-funguje")} className='no-underline'>{t('navigation.howItWorks')}</a></li>
                        <li><a href="#vyuziti" onClick={(e) => scrollToSection(e, "vyuziti")} className='no-underline'>{t('navigation.vrBenefits')}</a></li>
                        <li><a href="#vr-ve-zdravotnictvi" onClick={(e) => scrollToSection(e, "vr-ve-zdravotnictvi")} className='no-underline'>{t('navigation.vrInHealthcare')}</a></li>
                        <li><a href="#cenik" onClick={(e) => scrollToSection(e, "cenik")} className='no-underline'>{t('navigation.pricing')}</a></li>
                        <li><a href="#proc-vrpad" onClick={(e) => scrollToSection(e, "proc-vrpad")} className='no-underline'>{t('navigation.whyVrpad')}</a></li>
                    </ul>
                </nav>

                <div className='p-3'>
                    <LanguageSwitcher />
                </div>

                {/* Mobile contact button */}
                <div className="p-6 flex flex-col items-start gap-2">
                    <a href="tel:+420602257588" className="text-center rounded-lg no-underline" onClick={closeMenu}>
                        <FontAwesomeIcon icon={faPhone} className='mr-2' />
                        +420 602 257 588
                    </a>
                    <a href="mailto:info@vrpad.cz" className="text-center rounded-lg no-underline" onClick={closeMenu}>
                        <FontAwesomeIcon icon={faEnvelope} className='mr-2' />
                        info@vrpad.cz
                    </a>
                </div>
            </div>
        </>
    );
};

export default Header;
